import {RequestsModule} from "./requests/requests-module"
import {ModuleType} from "./types"
import {SharedViewsModule} from "./shared-views/shared-views-module"
import {PublicFormsModule} from "./public-forms/public-forms-module"
import {ExpensesModule} from "./expenses/expenses-module";
import {LaborCostModule} from "./labor-cost/labor-cost-module";
import {TwoFAModule} from "./2fa/two-fa-module";
import {GoogleDriveModule} from "./integrations/google-drive/google-drive";
import {GoogleCalendarModule} from "./integrations/google-calendar/google-calendar";
import {GoogleSuiteModule} from "./integrations/google-suite/google-suite";
import {GithubModule} from "./integrations/github/github";
import {GitlabModule} from "./integrations/gitlab/gitlab";
import {SlackModule} from "./integrations/slack/slack";
import {EventsModule} from "./events/events";
import {TagsModule} from "./tags/tags";
import {PublicSharingModule} from "./public-sharing/public-sharing";
import {PortfolioModule} from "./portfolio/portfolio";
import {AttachmentsModule} from "./attachments/attachments";
import {GoalsModule} from "./goals/goals";
import {RemindersModule} from "./reminders/reminders";
import {StoryPointsModule} from "./story-points/story-points";
import {PagesModule} from "./pages/pages";
import {ReportsAnalyticsModule} from "./reports-analytics/reports-analytics";
import {AutomationsModule} from "./automations/automations";
import {DashboardsModule} from "./dashboards/dashboards";
import {MeetingsModule} from "./meetings/meetings";
import {EmailTemplatesModule} from "./email-templates/email-templates-module";
import {EmailReplyModule} from "./integrations/email-reply/email-reply-module";
import {DocumentsModule} from "./documents/documents";
import {NotepadModule} from "./notepad/notepad";
import {ChatsModule} from "./chats/chats";
import {ViewListModule} from "./views/view-list";
import {ViewTableModule} from "./views/view-table";
import {ViewBoardModule} from "./views/view-board";
import {ViewCalendarModule} from "./views/view-calendar";
import {ViewGanttModule} from "./views/view-gantt";
import {ViewWorkloadModule} from "./views/view-workload";
import {TimeTrackingModule} from "./time-tracking/time-tracking";
import {ModuleClockInOut} from "./clock-in-out/clock-in-out";
import {GuesstimateModule} from "./guesstimate/guesstimate";
import CrmAccountModule from "./crm-account/crm-account";
import CrmContactModule from "./crm-contact/crm-contact";
import {CustomerPortalModule} from "./customer-portal/customer-portal";
import {ViewEventsSummaryModule} from "./views/view-events-summary";
import {ViewMyTimeModule} from "./views/view-my-time";
import {ViewMyCalendarModule} from "./views/view-my-calendar";
import {ViewMyTasksModule} from "./views/view-my-tasks";
import {ViewMyWorkloadModule} from "./views/view-my-workload";
import {ViewMyMeetingsModule} from "./views/view-my-meetings";
import {ViewMyDocumentsModule} from "./views/view-my-documents";
import {ViewWhatsDoneModule} from "./views/view-whats-done";
import {ViewPastDueModule} from "./views/view-past-due";
import {ViewPrioritiesModule} from "./views/view-priorities";
import {ViewActionRequiredModule} from "./views/view-action-required";
import {ViewTaskByUserModule} from "./views/view-task-by-user";
import {ViewDashboardModule} from "./views/view-dashboard";
import {ViewRecentModule} from "./views/view-recent";
import {ViewActivityStreamModule} from "./views/view-activity-stream";
import { CrmModule } from "./crm/crm";
import {GdLabsModule} from "./gd-labs/gd-labs";
import {InvoicesModule} from "./invoices/invoices";
import {ModuleWorkload} from "./workload/workload";
import {DropboxModule} from "./integrations/dropbox/dropbox";
import {SSOGoogleModule} from "./integrations/sso-google/sso-google";
import {CreateTaskViaEmailModule} from "./integrations/task-via-email/task-via-email";
import {ReactionsModule} from "./reactions/reactions-module";
import {OfficesModule} from "./offices/offices";
import {OutlookCalendarModule} from "./integrations/outlook-calendar/outlook-calendar";
import {SSOMicrosoftModule} from "./integrations/sso-microsoft/sso-microsoft";
import {MicrosoftEntraIDModule} from "./integrations/entra/entra";
import {ModuleCustomEntities} from "./custom-entities/custom-entities"
import {ModuleValidations} from "./validations/validations";
import {ModuleDependencies} from "./dependencies/dependencies";

// const debug = "Modules"
const debug = false

export default class Modules {

    public requests             : RequestsModule
    public publicForms          : PublicFormsModule
    public sharedViews          : SharedViewsModule
    public expenses             : ExpensesModule
    public invoices             : InvoicesModule
    public laborCost            : LaborCostModule
    public twoFA                : TwoFAModule
    public emailTemplates       : EmailTemplatesModule
    public emailReply           : EmailReplyModule
    public events               : EventsModule
    public tags                 : TagsModule
    public pages                : PagesModule
    public publicSharing        : PublicSharingModule
    public portfolio            : PortfolioModule
    public reportsAnalytics     : ReportsAnalyticsModule
    public attachments          : AttachmentsModule
    public automations          : AutomationsModule
    public goals                : GoalsModule
    public dashboards           : DashboardsModule
    public reminders            : RemindersModule
    public meetings             : MeetingsModule
    public storyPoints          : StoryPointsModule
    public documents            : DocumentsModule
    public notepad              : NotepadModule
    public chats                : ChatsModule
    public timeTracking         : TimeTrackingModule
    public workload             : ModuleWorkload
    public clockInOut           : ModuleClockInOut
    public guesstimate          : GuesstimateModule
    public crm                  : CrmModule
    public crmAccount           : CrmAccountModule
    public crmContact           : CrmContactModule
    public customerPortal       : CustomerPortalModule
    public gdLabs               : GdLabsModule
    public customEntities       : ModuleCustomEntities
    public validations          : ModuleValidations
    public dependencies         : ModuleDependencies

    public viewList             : ViewListModule
    public viewTable            : ViewTableModule
    public viewBoard            : ViewBoardModule
    public viewCalendar         : ViewCalendarModule
    public viewEventsSummary    : ViewEventsSummaryModule
    public viewGantt            : ViewGanttModule
    public viewWorkload         : ViewWorkloadModule
    public viewMyTime           : ViewMyTimeModule
    public viewMyCalendar       : ViewMyCalendarModule
    public viewMyTasks          : ViewMyTasksModule
    public viewMyWorkload       : ViewMyWorkloadModule
    public viewMyMeetings       : ViewMyMeetingsModule
    public viewMyDocuments      : ViewMyDocumentsModule
    public viewWhatsDone        : ViewWhatsDoneModule
    public viewPastDue          : ViewPastDueModule
    public viewPriorities       : ViewPrioritiesModule
    public viewActionRequired   : ViewActionRequiredModule
    public viewTaskByUser       : ViewTaskByUserModule
    public viewDashboard        : ViewDashboardModule
    public viewRecent           : ViewRecentModule
    public viewActivityStream   : ViewActivityStreamModule

    public googleDrive          : GoogleDriveModule
    public googleCalendar       : GoogleCalendarModule
    public outlookCalendar      : OutlookCalendarModule

    public googleSuite          : GoogleSuiteModule
    public github               : GithubModule
    public gitlab               : GitlabModule
    public slack                : SlackModule

    public dropbox              : DropboxModule

    public ssoGoogle            : SSOGoogleModule
    public ssoMicrosoft         : SSOMicrosoftModule
    public microsoftEntraID     : MicrosoftEntraIDModule
    public createTaskViaEmail   : CreateTaskViaEmailModule
    public reactions            : ReactionsModule
    public offices              : OfficesModule


    constructor(modulesConfig:any) {

        debug && console.log(debug, "Constructor()", modulesConfig)

        this.requests           = new RequestsModule(_.get(modulesConfig, ModuleType.REQUESTS,{}))
        this.publicForms        = new PublicFormsModule(_.get(modulesConfig, ModuleType.PUBLIC_FORMS,{}))
        this.sharedViews        = new SharedViewsModule(_.get(modulesConfig, ModuleType.SHARED_VIEWS,{}))
        this.expenses           = new ExpensesModule(_.get(modulesConfig, ModuleType.EXPENSES,{}))
        this.invoices           = new InvoicesModule(_.get(modulesConfig, ModuleType.INVOICES,{}))
        this.laborCost          = new LaborCostModule(_.get(modulesConfig, ModuleType.LABOR_COST,{}))
        this.twoFA              = new TwoFAModule(_.get(modulesConfig, ModuleType.TWO_FA,{}))
        this.emailReply         = new EmailReplyModule(_.get(modulesConfig, ModuleType.EMAIL_REPLY,{}))
        this.emailTemplates     = new EmailTemplatesModule({})   // _.get(modulesConfig, ModuleType.EMAIL_TEMPLATES,{})
        this.events             = new EventsModule(_.get(modulesConfig, ModuleType.EVENTS,{}))
        this.tags               = new TagsModule(_.get(modulesConfig, ModuleType.TAGS,{}))
        this.pages              = new PagesModule(_.get(modulesConfig, ModuleType.PAGES,{}))
        this.publicSharing      = new PublicSharingModule(_.get(modulesConfig, ModuleType.PUBLIC_SHARING,{}))
        this.portfolio          = new PortfolioModule(_.get(modulesConfig, ModuleType.PORTFOLIO,{}))
        this.reportsAnalytics   = new ReportsAnalyticsModule(_.get(modulesConfig, ModuleType.REPORTS_ANALYTICS,{}))
        this.attachments        = new AttachmentsModule(_.get(modulesConfig, ModuleType.ATTACHMENTS,{}))
        this.automations        = new AutomationsModule(_.get(modulesConfig, ModuleType.AUTOMATIONS,{}))
        this.goals              = new GoalsModule(_.get(modulesConfig, ModuleType.GOALS,{}))
        this.dashboards         = new DashboardsModule(_.get(modulesConfig, ModuleType.DASHBOARDS,{}))
        this.reminders          = new RemindersModule(_.get(modulesConfig, ModuleType.REMINDERS,{}))
        this.meetings           = new MeetingsModule(_.get(modulesConfig, ModuleType.MEETINGS,{}))
        this.storyPoints        = new StoryPointsModule(_.get(modulesConfig, ModuleType.STORY_POINTS,{}))
        this.documents          = new DocumentsModule(_.get(modulesConfig, ModuleType.DOCUMENTS,{}))
        this.notepad            = new NotepadModule(_.get(modulesConfig, ModuleType.NOTEPAD,{}))
        this.chats              = new ChatsModule(_.get(modulesConfig, ModuleType.CHATS,{}))
        this.timeTracking       = new TimeTrackingModule(_.get(modulesConfig, ModuleType.TIME_TRACKING,{}))
        this.workload           = new ModuleWorkload(_.get(modulesConfig, ModuleType.WORKLOAD,{}))
        this.clockInOut         = new ModuleClockInOut(_.get(modulesConfig, ModuleType.CLOCK_IN_OUT,{}))
        this.guesstimate        = new GuesstimateModule(_.get(modulesConfig, ModuleType.GUESSTIMATE,{}))

        this.crm                = new CrmModule(_.get(modulesConfig, ModuleType.CRM,{})) // must init before other crm modules

        this.crmAccount         = new CrmAccountModule(_.get(modulesConfig, ModuleType.CRM_ACCOUNT,{}))
        this.crmContact         = new CrmContactModule(_.get(modulesConfig, ModuleType.CRM_CONTACT,{}))
        this.customerPortal     = new CustomerPortalModule(_.get(modulesConfig, ModuleType.CUSTOMER_PORTAL,{}))


        this.gdLabs             = new GdLabsModule(_.get(modulesConfig, ModuleType.GD_LABS,{}))

        this.customEntities     = new ModuleCustomEntities(_.get(modulesConfig, ModuleType.CUSTOM_ENTITIES,{}))
        this.validations              = new ModuleValidations(_.get(modulesConfig, ModuleType.VALIDATIONS,{}))
        this.dependencies       = new ModuleDependencies(_.get(modulesConfig, ModuleType.DEPENDENCIES,{}))

        this.viewList           = new ViewListModule(_.get(modulesConfig, ModuleType.VIEW_LIST,{}))
        this.viewTable          = new ViewTableModule(_.get(modulesConfig, ModuleType.VIEW_TABLE,{}))
        this.viewBoard          = new ViewBoardModule(_.get(modulesConfig, ModuleType.VIEW_BOARD,{}))
        this.viewCalendar       = new ViewCalendarModule(_.get(modulesConfig, ModuleType.VIEW_CALENDAR,{}))
        this.viewEventsSummary  = new ViewEventsSummaryModule(_.get(modulesConfig, ModuleType.VIEW_EVENTS_SUMMARY,{}))
        this.viewGantt          = new ViewGanttModule(_.get(modulesConfig, ModuleType.VIEW_GANTT,{}))
        this.viewWorkload       = new ViewWorkloadModule(_.get(modulesConfig, ModuleType.VIEW_WORKLOAD,{}))
        this.viewMyTime         = new ViewMyTimeModule(_.get(modulesConfig, ModuleType.VIEW_MY_TIME,{}))
        this.viewMyCalendar     = new ViewMyCalendarModule(_.get(modulesConfig, ModuleType.VIEW_MY_CALENDAR,{}))
        this.viewMyTasks        = new ViewMyTasksModule(_.get(modulesConfig, ModuleType.VIEW_MY_TASKS,{}))
        this.viewMyWorkload     = new ViewMyWorkloadModule(_.get(modulesConfig, ModuleType.VIEW_MY_WORKLOAD,{}))
        this.viewMyMeetings     = new ViewMyMeetingsModule(_.get(modulesConfig, ModuleType.VIEW_MY_MEETINGS,{}))
        this.viewMyDocuments    = new ViewMyDocumentsModule(_.get(modulesConfig, ModuleType.VIEW_MY_DOCUMENTS,{}))
        this.viewWhatsDone      = new ViewWhatsDoneModule(_.get(modulesConfig, ModuleType.VIEW_WHATS_DONE,{}))
        this.viewPastDue        = new ViewPastDueModule(_.get(modulesConfig, ModuleType.VIEW_PAST_DUE,{}))
        this.viewPriorities     = new ViewPrioritiesModule(_.get(modulesConfig, ModuleType.VIEW_PRIORITIES,{}))
        this.viewActionRequired = new ViewActionRequiredModule(_.get(modulesConfig, ModuleType.VIEW_ACTION_REQUIRED,{}))
        this.viewTaskByUser     = new ViewTaskByUserModule(_.get(modulesConfig, ModuleType.VIEW_TASK_BY_USER,{}))
        this.viewDashboard      = new ViewDashboardModule(_.get(modulesConfig, ModuleType.VIEW_DASHBOARD,{}))
        this.viewRecent         = new ViewRecentModule(_.get(modulesConfig, ModuleType.VIEW_RECENT,{}))
        this.viewActivityStream = new ViewActivityStreamModule(_.get(modulesConfig, ModuleType.VIEW_ACTIVITY_STREAM,{}))

        this.googleDrive        = new GoogleDriveModule()

        this.slack              = new SlackModule()

        this.googleCalendar     = new GoogleCalendarModule()
        this.outlookCalendar    = new OutlookCalendarModule()
        this.googleSuite        = new GoogleSuiteModule()
        this.github             = new GithubModule()
        this.gitlab             = new GitlabModule()

        // last integrations
        this.dropbox            = new DropboxModule()
        this.ssoGoogle          = new SSOGoogleModule()
        this.microsoftEntraID   = new MicrosoftEntraIDModule()
        this.ssoMicrosoft       = new SSOMicrosoftModule()
        this.createTaskViaEmail = new CreateTaskViaEmailModule()
        this.reactions          = new ReactionsModule(_.get(modulesConfig, ModuleType.REACTIONS,{}))
        this.offices            = new OfficesModule(_.get(modulesConfig, ModuleType.OFFICES,{}))

    }

    saveConfig():void {

        debug && console.log(debug, "saveConfig() expensesIsntanceId=", this.expenses.instanceId, " expenses._isEnabled", this.expenses._isEnabled)

        const config:JSONObject = {
            [ModuleType.REQUESTS]           : this.requests.toJson(),
            [ModuleType.SHARED_VIEWS]       : this.sharedViews.toJson(),
            [ModuleType.PUBLIC_FORMS]       : this.publicForms.toJson(),
            [ModuleType.EXPENSES]           : this.expenses.toJson(),
            [ModuleType.INVOICES]           : this.invoices.toJson(),
            [ModuleType.LABOR_COST]         : this.laborCost.toJson(),
            [ModuleType.TWO_FA]             : this.twoFA.toJson(),
            // [ModuleType.EMAIL_TEMPLATES]    : this.emailTemplates.toJson(),
            [ModuleType.EVENTS]             : this.events.toJson(),
            [ModuleType.TAGS]               : this.tags.toJson(),
            [ModuleType.PAGES]              : this.pages.toJson(),
            [ModuleType.PUBLIC_SHARING]     : this.publicSharing.toJson(),
            [ModuleType.PORTFOLIO]          : this.portfolio.toJson(),
            [ModuleType.REPORTS_ANALYTICS]  : this.reportsAnalytics.toJson(),
            [ModuleType.ATTACHMENTS]        : this.attachments.toJson(),
            [ModuleType.AUTOMATIONS]        : this.automations.toJson(),
            [ModuleType.GOALS]              : this.goals.toJson(),
            [ModuleType.DASHBOARDS]         : this.dashboards.toJson(),
            [ModuleType.REMINDERS]          : this.reminders.toJson(),
            [ModuleType.MEETINGS]           : this.meetings.toJson(),
            [ModuleType.STORY_POINTS]       : this.storyPoints.toJson(),
            [ModuleType.DOCUMENTS]          : this.documents.toJson(),
            [ModuleType.NOTEPAD]            : this.notepad.toJson(),
            [ModuleType.CHATS]              : this.chats.toJson(),
            [ModuleType.TIME_TRACKING]      : this.timeTracking.toJson(),
            [ModuleType.CLOCK_IN_OUT]       : this.clockInOut.toJson(),
            [ModuleType.GUESSTIMATE]        : this.guesstimate.toJson(),
            [ModuleType.CRM_ACCOUNT]        : this.crmAccount.toJson(),
            [ModuleType.CRM_CONTACT]        : this.crmContact.toJson(),
            [ModuleType.CRM]                : this.crm.toJson(),
            [ModuleType.CUSTOMER_PORTAL]    : this.customerPortal.toJson(),
            [ModuleType.GD_LABS]            : this.gdLabs.toJson(),
            // [ModuleType.DEPENDENCIES]       : this.rules.toJson(),
            [ModuleType.VALIDATIONS]              : this.validations.toJson(),
            // [ModuleType.CUSTOM_ENTITIES]    : this.customEntities.toJson(),

            [ModuleType.VIEW_LIST]           : this.viewList.toJson(),
            [ModuleType.VIEW_TABLE]          : this.viewTable.toJson(),
            [ModuleType.VIEW_BOARD]          : this.viewBoard.toJson(),
            [ModuleType.VIEW_CALENDAR]       : this.viewCalendar.toJson(),
            [ModuleType.VIEW_EVENTS_SUMMARY] : this.viewEventsSummary.toJson(),
            [ModuleType.VIEW_GANTT]          : this.viewGantt.toJson(),
            [ModuleType.VIEW_WORKLOAD]       : this.viewWorkload.toJson(),
            [ModuleType.VIEW_MY_TIME]        : this.viewMyTime.toJson(),
            [ModuleType.VIEW_MY_CALENDAR]    : this.viewMyCalendar.toJson(),
            [ModuleType.VIEW_MY_TASKS]       : this.viewMyTasks.toJson(),
            [ModuleType.VIEW_MY_WORKLOAD]    : this.viewMyWorkload.toJson(),
            [ModuleType.VIEW_MY_MEETINGS]    : this.viewMyMeetings.toJson(),
            [ModuleType.VIEW_MY_DOCUMENTS]   : this.viewMyDocuments.toJson(),
            [ModuleType.VIEW_WHATS_DONE]     : this.viewWhatsDone.toJson(),
            [ModuleType.VIEW_PAST_DUE]       : this.viewPastDue.toJson(),
            [ModuleType.VIEW_PRIORITIES]     : this.viewPriorities.toJson(),
            [ModuleType.VIEW_ACTION_REQUIRED]: this.viewActionRequired.toJson(),
            [ModuleType.VIEW_TASK_BY_USER]   : this.viewTaskByUser.toJson(),
            [ModuleType.VIEW_DASHBOARD]      : this.viewDashboard.toJson(),
            [ModuleType.VIEW_RECENT]         : this.viewRecent.toJson(),
            [ModuleType.VIEW_ACTIVITY_STREAM]: this.viewActivityStream.toJson(),
            [ModuleType.REACTIONS]           : this.reactions.toJson(),
            [ModuleType.OFFICES]             : this.offices.toJson(),


            // [ModuleType.GOOGLE_CALENDAR]    : this.googleCalendar.toJson(),
            // [ModuleType.GOOGLE_SUITE]       : this.googleSuite.toJson(),
            // [ModuleType.GITHUB]             : this.github.toJson(),
            // [ModuleType.GITLAB]             : this.gitlab.toJson(),
            // [ModuleType.SLACK]              : this.slack.toJson(),

            // last integrations
            // [ModuleType.DROPBOX]            : this.dropbox.toJson(),
            // [ModuleType.GOOGLE]             : this.ssoGoogle.toJson(),
            // [ModuleType.TASK_VIA_EMAIL]     : this.createTaskViaEmail.toJson(),
            [ModuleType.EMAIL_REPLY]        : this.emailReply.toJson(),

        }

        gd.company.settings._modulesConfig = config
        gd.company.settings.save()

    }
}
